// extracted by mini-css-extract-plugin
export default {"Logo":"LeftPanel_Logo__Va-G0","Menu":"LeftPanel_Menu__j+5A-","Sider":"LeftPanel_Sider__IGZ8i","LegalLinks":"LeftPanel_LegalLinks__FJJt+","LegalLink":"LeftPanel_LegalLink__JHrlT"};